import LazyLoad from 'vanilla-lazyload';

const lazyLoad = new LazyLoad({
    elements_selector: '.lazy',
});

// Ajax load more woocommerce plugin
$(document).on('berocket_lmp_end', () => lazyLoad.update())

// Woocommerce events
let wooEvents = [
  'init_checkout',
  'payment_method_selected',
  'update_checkout',
  'updated_checkout',
  'checkout_error',
  'wc_fragments_refreshed',
  'wc_fragments_loaded',
]
wooEvents.map(event => {
  $(document.body).on(event, () => lazyLoad.update())
})

window._lazy = lazyLoad;



// WEBPACK FOOTER //
// ./scripts/autoload/_lazy-load.js